import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3Icon, ChevronRightIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { eventTitle, eventTypeClass, eventTypeShort, formatDate } from '../../utils/labels';
export function AdminAttendanceIndex() {
  const {
    events,
    attendance,
    today,
    expectedFor
  } = useApp();
  const relevantni = events.filter(e => e.steje).sort((a, b) => Math.abs(+new Date(a.datum) - +new Date(today)) - Math.abs(+new Date(b.datum) - +new Date(today))).slice(0, 10).sort((a, b) => b.datum.localeCompare(a.datum));
  return <div className="space-y-5" data-id="element-586" data-mp="2cswmlv2w5p7v">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-587" data-mp="5zug0gzlcg0e">
        <div data-id="element-588" data-mp="5yjd0jdyzcac">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-589" data-mp="az71axatdf0v">Prisotnost</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-590" data-mp="axcoy7dlyv8e">Vpis prisotnosti po dogodkih.</p>
        </div>
        <Link to="/admin/porocilo" data-id="element-591" data-mp="1l2usw9ybakdi">
          <Button variant="secondary" data-id="element-592" data-mp="1g6e8nqu8gq5p">
            <BarChart3Icon className="h-4 w-4" data-id="element-593" data-mp="1g5csj7yd1dh4" />
            Poročilo in analitika
          </Button>
        </Link>
      </div>

      <Card className="divide-y divide-line" data-id="element-594" data-mp="1tz3rxnidngz4">
        {relevantni.map(e => {
        const marks = attendance[e.id];
        const prisotnih = marks ? Object.values(marks).filter(m => m === 'prisoten').length : null;
        return <Link key={e.id} to={`/admin/prisotnost/${e.id}`} className="flex flex-wrap items-center gap-3 px-5 py-4 transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-595" data-mp="x81x5yfun46y">
              <span className="w-24 shrink-0 text-[13px] font-medium text-ink" data-id="element-596" data-mp="166dl1spbznvp">{formatDate(e.datum)}</span>
              <span className="min-w-0 flex-1" data-id="element-597" data-mp="2mo1cjxa29pv1">
                <span className="block truncate text-sm font-medium text-ink" data-id="element-598" data-mp="2hnn2k9owg5ud">{eventTitle(e)}</span>
                <span className="block text-[13px] text-ink-muted" data-id="element-599" data-mp="1fa8pjld1dxhe">
                  {e.zacetek} · {e.lokacija} · {expectedFor(e).length} pričakovanih
                </span>
              </span>
              <Badge className={eventTypeClass[e.type]} data-id="element-600" data-mp="1o9lxuapfcg0j">{eventTypeShort[e.type]}</Badge>
              {marks ? <Badge className="bg-green-50 text-green-700 border-green-200" dot="bg-green-500" data-id="element-601" data-mp="1t85p8qmsek0a">
                  {prisotnih} prisotnih
                </Badge> : <Badge className="bg-amber-50 text-amber-800 border-amber-200" data-id="element-602" data-mp="10k1cxm9pn8om">Ni vpisana</Badge>}
              <ChevronRightIcon className="h-4 w-4 text-ink-muted" data-id="element-603" data-mp="15il35yvc76ms" />
            </Link>;
      })}
      </Card>
    </div>;
}